import {useColorSchemeVar} from '@primer/react'

export default function MonaSearchImage() {
  const lightIllustrationPath = '/images/modules/search/light.png'
  const lightIllustration2xPath = '/images/modules/search/light2x.png'

  const darkIllustrationPath = '/images/modules/search/dark.png'
  const darkIllustration2xPath = '/images/modules/search/dark2x.png'

  const themeAwareMona = useColorSchemeVar(
    {
      light: lightIllustrationPath,
      light_colorblind: lightIllustrationPath,
      dark: darkIllustrationPath,
      dark_colorblind: darkIllustrationPath,
      dark_dimmed: darkIllustrationPath,
      dark_high_contrast: darkIllustrationPath,
    },
    lightIllustrationPath,
  )

  const themeAwareMona2x = useColorSchemeVar(
    {
      light: lightIllustration2xPath,
      light_colorblind: lightIllustration2xPath,
      dark: darkIllustration2xPath,
      dark_colorblind: darkIllustration2xPath,
      dark_dimmed: darkIllustration2xPath,
      dark_high_contrast: darkIllustration2xPath,
    },
    lightIllustration2xPath,
  )

  return (
    <img
      alt="Mona looking through a globe hologram for code"
      src={themeAwareMona}
      srcSet={`${themeAwareMona} 1x, ${themeAwareMona2x} 2x`}
      width="100%"
      style={{display: 'block'}}
    />
  )
}

try{ MonaSearchImage.displayName ||= 'MonaSearchImage' } catch {}